var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 1366",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dynamic_Info Page-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #4bccea } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m321.1 430.5c-8.7-6.5-21-4.7-27.5 4l-23.6 31.4v-117.9c0-10.8-8.8-19.6-19.6-19.6-10.9 0-19.7 8.8-19.7 19.6v117.9l-23.6-31.4c-6.4-8.7-18.7-10.5-27.5-4-8.6 6.5-10.4 18.8-3.9 27.5l59 78.6c3.7 4.9 9.5 7.8 15.7 7.8 6.2 0 12-2.9 15.7-7.8l58.9-78.6c6.5-8.7 4.8-21-3.9-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m325 748.7l-58.9-78.5c-7.4-9.9-24-9.9-31.4 0l-59 78.5c-6.5 8.7-4.7 21 3.9 27.5 8.8 6.5 21.1 4.8 27.5-3.9l23.6-31.4v117.8c0 10.9 8.8 19.7 19.7 19.7 10.8 0 19.6-8.8 19.6-19.7v-117.8l23.6 31.4c3.8 5.2 9.7 7.9 15.7 7.9 4.1 0 8.2-1.3 11.8-4 8.7-6.5 10.4-18.8 3.9-27.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m741.5 623c-7.3 0-14.2-4-17.6-10.8l-37.6-75.2c-10.9-3.5-45.5-1.2-63.7 13.7-8.7 7.1-11 14.9-7.6 26.2 3.1 10.4-2.8 21.4-13.2 24.4-10.4 3.1-21.4-2.8-24.5-13.2-10.7-36 6.4-66.8 45.9-82.4 31.2-12.3 83.5-15.8 96.5 10.3l39.3 78.6c4.9 9.7 0.9 21.5-8.8 26.3-2.8 1.4-5.8 2.1-8.7 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m849.5 583.1c-7.4 0-14.5-4.2-17.8-11.4-0.1-0.2-9.4-20.2-27.6-54.6-5.8-2.1-23.1-3.3-40.6 4.6-15.6 7.1-25.1 18.7-28 34.7-2 10.7-12.2 17.6-23 15.7-10.6-2-17.7-12.3-15.7-22.9 8.5-45.3 46.4-66.7 79-71.7 22-3.3 51.5-0.6 61.6 18.5 19.7 37.1 29.5 58.3 29.9 59.2 4.6 9.8 0.3 21.5-9.5 26.1-2.7 1.2-5.5 1.8-8.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m780.7 1114.1c-109.1 0-158.2-37.9-232.5-95.4-10.9-8.3-22.3-17.2-34.6-26.4-96.1-72.2-169.9-94.9-170.7-95.1-8.3-2.5-14-10.2-14-18.8 0-61.5 51.4-98.2 137.5-98.2 45.4 0 108.2 21.4 131.8 45 7.7 7.7 7.7 20.1 0 27.8-7.7 7.7-20.1 7.7-27.8 0-14.8-14.8-66.7-33.6-104-33.6-26.8 0-86 4.8-96.6 45.6 28 10.7 90.8 38.4 167.4 95.9 12.4 9.3 24 18.3 35 26.8 70.3 54.3 112.8 87.1 208.5 87.1 137.2 0 251.9-118.6 255.4-216.8 0-72.2-62-249.4-95.3-303.2-13.3-21.5-28.6-33.9-44.2-35.7-17.3-1.9-33 9.5-43.1 19.6-7.6 7.7-20.1 7.7-27.7 0-7.7-7.7-7.7-20.1 0-27.8 23.2-23.2 49.3-33.9 75.3-30.8 19.5 2.3 48 13.5 73.1 54 32.5 52.4 101.2 239.7 101.2 324.6-5.1 141.8-165.3 255.4-294.7 255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m584.3 878.4c-5 0-10.1-1.9-13.9-5.8-7.5-7.5-7.7-19.5-0.5-27.3 0.9-1.1 9-12.5-3.2-36.7l-207.5-362.3c-21.4-37.4-9.4-85.5 26.8-107.2 17.3-10.4 37.8-13.4 57.6-8.4 20.4 5.3 37.6 18.2 48.4 36.6l168.1 285c5.6 9.4 2.5 21.4-6.9 26.9-9.3 5.5-21.4 2.4-26.9-6.9l-168.1-285.1c-5.5-9.3-14.1-15.8-24.3-18.4-9.6-2.4-19.4-1-27.7 3.9-18 10.8-23.8 35.1-12.9 54.1l208 363.2c21.1 42 7.9 71.6-3.1 82.6-3.9 3.9-8.9 5.8-13.9 5.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileZoom);
export default __webpack_public_path__ + "static/media/mobile-zoom.6782c6d8876b9a13446ea24c50f4c5c4.svg";
export { ForwardRef as ReactComponent };